import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';

import Text from '../Boneyard/Text';
import Box from '@g4/boneyard/lib/Box';

const FieldName = ({ themeColor, theme, children }) => {
  return (
    <Box mt={2} mb={2}>
      <Text color={theme.colors.hob[themeColor].label} children={children} />
    </Box>
  );
};

FieldName.propTypes = {
  themeColor: PropTypes.oneOf(['blueSearchWidget', 'greySearchWidget']),
  theme: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default withTheme(FieldName);
